// A locked file: nobody may change it until it is unlocked. Shown next to its
// name; the tooltip says who locked it and why.

import { LockKeyhole } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { isLockedByMe, lockOf } from '@/shared/utils/nodeAccess.js';
import { fileStateText } from '@/shared/utils/fileStateText.js';

export function LockBadge({ node, className }) {
  const { t } = useTranslation(['my-docs', 'editor']);
  const lock = lockOf(node);
  if (!lock) return null;
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-full border border-amber-300/70 bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-800 dark:border-amber-800 dark:bg-amber-900/30 dark:text-amber-200', className)}
      title={fileStateText(t, 'locked', lock, { mine: isLockedByMe(node) })}
      data-testid="lock-badge"
    >
      <LockKeyhole className="h-3 w-3" /> {t('my-docs:lock.badge')}
    </span>
  );
}
